import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Annuncio } from '../models/annuncio';
import { AnnuncioAllegato } from '../models/annuncio-allegato';
import { ResourcefulService } from './resourcefulService';

@Injectable({
  providedIn: 'root'
})
export class AnnuncioService extends ResourcefulService<Annuncio> {
  constructor(private httpClient: HttpClient) {
    super(httpClient, Annuncio);
  }

  markAsRead(annuncio: Annuncio): Promise<{ read_at: string }> {
    return this._httpClient.post<{ read_at: string }>(
      `${this.baseUrl}/${Annuncio.apiUrl}/${annuncio.id}/mark-as-read`,
      {}
    ).toPromise();
  }

  getAllegati(annuncioId: number): Promise<AnnuncioAllegato[]> {
    return this._httpClient
      .get<{ data: any[] }>(`${this.baseUrl}/annunci/${annuncioId}/allegati`)
      .toPromise()
      .then(response => response.data.map(item => new AnnuncioAllegato().deserialize(item)));
  }

  uploadAllegato(annuncioId: number, file: File): Observable<AnnuncioAllegato> {
    const formData = new FormData();
    formData.append('file', file);
    return this._httpClient
      .post<any>(`${this.baseUrl}/annunci/${annuncioId}/allegati`, formData)
      .pipe(map(response => new AnnuncioAllegato().deserialize(response?.data ?? response)));
  }

  deleteAllegato(annuncioId: number, allegatoId: number): Promise<void> {
    return this._httpClient
      .delete<void>(`${this.baseUrl}/annunci/${annuncioId}/allegati/${allegatoId}`)
      .toPromise();
  }

  downloadAllegato(annuncioId: number, allegatoId: number) {
    return this._httpClient.get(`${this.baseUrl}/annunci/${annuncioId}/allegati/${allegatoId}/download`, {
      responseType: 'blob',
      observe: 'response'
    }) as unknown as Observable<HttpResponse<Blob>>;
  }
}
